import React from "react";
import "../../style/Reusable.css";
import "../../style/components/BlogList.css";

import { useNavigate, Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import LazyImage from "../generics/LazyImage";
import { fetchBlogDetails } from "../../api/blog/blog.reduxThunk";
import { setBlogDetailsEmpty } from "../../api/xoicom.reducer";
const USE_BLOG_SLUG = process.env.REACT_APP_USE_BLOG_SLUG === "TRUE";

export const getCategoryString = (blogCategories) => {
  let categoryString = [];
  if (blogCategories) {
    categoryString = blogCategories.filter((category) => category);
  }
  const categories = categoryString.join(" • ");
  if (!categories) return "";
  else return ` • ${categories}`;
};

function BlogCard({ blog }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const inner = (
    <>
      <div className="blog-card-image-container">
        <LazyImage
          className="zoom"
          imgClass="blog-card-image"
          imageSrc={blog.previewImage}
          alt={blog.title}
        />
      </div>
      <div className="blog-card-text">
        <div className="blog-card-text-heading body-b2">{blog.heading}</div>
        <div className="blog-card-subtitle">
          {blog.date}
          {getCategoryString(blog.categoryDisplayName)}
        </div>
      </div>
    </>
  );

  if (USE_BLOG_SLUG) {
    return (
      <Link
        className="blog-card"
        to={`/blog/${blog.slug}`}
        onClick={() => dispatch(setBlogDetailsEmpty())}
      >
        {inner}
      </Link>
    );
  }

  return (
    <div
      className="blog-card"
      onClick={() =>
        dispatch(fetchBlogDetails(blog.id))
          .unwrap()
          .then(() => navigate(`/blog/${blog.id}`))
      }
    >
      {inner}
    </div>
  );
}

export default BlogCard;
